import { ITCIValidationError, TCIActionState } from "./tci-validation";
import { ITCIApplicationOwner, ITCIApplicationCopy } from "./tci-application";
import { ITCIApplicationRequest, ITCIApplicationResponse } from "./tci-tenant";

/**
 * TCI Application Tenancy
 */
export class TCIApplicationTenancyAction {
    public static TENANT_TRANSFER_OWNERSHIP = 1;
    public static TENANT_COPY_APPLICATION = 2;
    public static TENANT_REPLACE_APPLICATION = 3;
}

/**
 * interface @ITCIApplicationTenancyRequest
 */
export interface ITCIApplicationTenancyRequest extends ITCIApplicationRequest {
    /**
     * Tenancy action to be performed
     */
    tenantAction: TCIApplicationTenancyAction | number;
    /**
     * Tenant owner to be used in ownership actions
     */
    tenantOwner?: ITCIApplicationOwner;
    /**
     * Subscription used in tenancy action input
     */
    subscription?: string;
    targetSbscId?: string;
    /**
     * Used for app copy action
     */
    tenantAppCopy?: ITCIApplicationCopy;

    /**
     * Used for app replacement
     */
    replaceSourceAppId?: string;
    /**
     * Tenant Extension Object
     */
    ext?: { [name: string]: any};
}

/**
 * interface @ITCIApplicationTenancyResponse
 */
export interface ITCIApplicationTenancyResponse extends ITCIApplicationResponse {
    /**
     * Tenancy action to be performed
     */
    tenantAction: TCIApplicationTenancyAction | number;
    /**
     * Tenancy action performed by user name
     */
    user: string;
    /**
     * Validation State
     * @private
     */
    state: TCIActionState | number;
    /**
     * Validation Errors
     * @private
     */
    errors: ITCIValidationError[];

}
